<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <h2 mat-dialog-title>{{ titleKey | translate }}</h2>

  <mat-dialog-content>
    <app-input-wrapper
      [label]="'deviceGroups.form.name' | translate"
      [control]="form.controls['name']"
    >
      <input
        type="text"
        formControlName="name"
        [placeholder]="'deviceGroups.form.name' | translate"
      />
    </app-input-wrapper>

    <app-input-wrapper
      [label]="'deviceGroups.form.devices' | translate"
      [control]="form.controls['deviceIds']"
    >
      <div class="w-full">
        <input
          type="search"
          formControlName="deviceSearch"
          [placeholder]="'default.search' | translate"
          [matAutocomplete]="deviceAuto"
        />

        <mat-chip-set class="selected-device-chips">
          @for (device of selectedDevices$ | async; track device.id) {
            <mat-chip removable="true" (removed)="removeDevice(device.id)">
              {{ device.name }}
              @if (device.isOutOfService) {
                <app-tag level="disabled">
                  {{ "devices.detail.outOfService.short" | translate }}
                </app-tag>
              }
              <button
                matChipRemove
                type="button"
                class="button icon-button small mat-chip-remove-button"
                [attr.aria-label]="'default.delete' | translate"
              >
                <app-icon name="ic_close" />
              </button>
            </mat-chip>
          }
        </mat-chip-set>
      </div>

      <mat-autocomplete
        #deviceAuto="matAutocomplete"
        (optionSelected)="addDevice($event.option.value)"
      >
        @for (device of availableDevices$ | async; track device.id) {
          <mat-option [value]="device.id">
            {{ device.name }}
            @if (device.isOutOfService) {
              <app-tag level="disabled">
                {{ "devices.detail.outOfService.short" | translate }}
              </app-tag>
            }
          </mat-option>
        } @empty {
          <mat-option disabled>{{ "devices.empty" | translate }}</mat-option>
        }
      </mat-autocomplete>
    </app-input-wrapper>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="button" class="button" mat-dialog-close>
      {{ "default.cancel" | translate }}
    </button>
    <button class="button primary-button" [disabled]="form.invalid">
      {{ "default.save" | translate }}
    </button>
  </mat-dialog-actions>
</form>
